module.exports = __webpack_public_path__ + "static/media/group_25.fb62f199.png";